import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useUser } from "@/components/providers/user-context";
import { Button } from "@/components/ui/button";

export function ThemeToggle() {
  const { setTheme, theme } = useTheme();
  const { updatePreferences } = useUser();

  const handleThemeChange = (newTheme: "light" | "dark") => {
    setTheme(newTheme);
    updatePreferences({ theme: newTheme });
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => handleThemeChange(theme === "light" ? "dark" : "light")}
      aria-label="Toggle theme"
    >
      <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
    </Button>
  );
}
